"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _KeyedAutoCompleteInput = _interopRequireDefault(require("../KeyedAutoCompleteInput/KeyedAutoCompleteInput"));

var _displayModes = require("../../../constants/displayModes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AutoCompleteInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AutoCompleteInput, _React$PureComponent);

  var _super = _createSuper(AutoCompleteInput);

  function AutoCompleteInput() {
    _classCallCheck(this, AutoCompleteInput);

    return _super.apply(this, arguments);
  }

  _createClass(AutoCompleteInput, [{
    key: "render",
    value: function render() {
      var props = _extends({}, this.props);

      return /*#__PURE__*/_react.default.createElement(_KeyedAutoCompleteInput.default, props);
    }
  }]);

  return AutoCompleteInput;
}(_react.default.PureComponent);

_defineProperty(AutoCompleteInput, "propTypes", {
  /** set autoFocus on Input */
  autoFocus: _propTypes.default.bool,

  /** Styling Overwrite Hook */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** Flag used for indicating an error state for the input */
  error: _propTypes.default.string,

  /** Overrides list behavior to show list immediately */
  forceShowList: _propTypes.default.bool,

  /** Get Autocomplete Suggestions hook */
  getAutocompleteSuggestions: _propTypes.default.func.isRequired,

  /** Max Autocomplete Suggestions */
  maxSuggestions: _propTypes.default.number,

  /** Minimum Autocomplete Characters - Minimum number of characters before autocomplete calls are made */
  minimumAutocompleteChars: _propTypes.default.number,

  /** mode flag - 'viewOnly', 'viewing', or 'editOnly' */
  mode: _propTypes.default.oneOf([undefined, _displayModes.displayModes.viewOnly, _displayModes.displayModes.viewing, _displayModes.displayModes.editOnly]),

  /** onChange handler */
  onChange: _propTypes.default.func.isRequired,

  /** Autocomplete suggestions */
  suggestions: _propTypes.default.shape({
    suggestionItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      primaryText: _propTypes.default.string.isRequired,
      secondaryText: _propTypes.default.string,
      suggestionId: _propTypes.default.string
    })).isRequired,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  }).isRequired,

  /** Time in ms to wait after typing before sending autocomplete trigger */
  typeDelay: _propTypes.default.number,

  /** Value of the input */
  value: _propTypes.default.string.isRequired,

  /** Override for debounce */
  _debounceOverwriteFn: _propTypes.default.func
});

_defineProperty(AutoCompleteInput, "defaultProps", {
  autoFocus: false,
  className: '',
  _debounceOverwriteFn: _lodash.debounce,
  disabled: false,
  error: '',
  forceShowList: false,
  maxSuggestions: 5,
  minimumAutocompleteChars: 3,
  mode: _displayModes.displayModes.editOnly,
  typeDelay: 500
});

var _default = AutoCompleteInput;
exports.default = _default;